module.exports = __webpack_public_path__ + "img/0S6A0231.25b49678.jpg";